import React from "react";
import { Typography } from "@mui/material";
import { MessageSquare } from "lucide-react";

// Phone preview styles - extracted and adapted for SMS
const phoneStyles = {
  container: {
    position: "relative",
    margin: "0 auto",
    border: "10px solid #1A1A1A",
    borderRadius: "55px",
    height: "700px",
    width: "340px",
    background: "#000",
    boxShadow:
      "0 0 20px rgba(0, 0, 0, 0.2), inset 0 0 10px rgba(255, 255, 255, 0.1)",
    overflow: "hidden",
  },
  dynamicIsland: {
    position: "absolute",
    top: "12px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "120px",
    height: "25px",
    background: "#000",
    borderRadius: "20px",
    zIndex: 10,
  },
  screen: {
    height: "100%",
    background: "#fff",
    position: "relative",
    overflow: "auto", // Enable scroll for the whole phone screen
    borderRadius: "40px",
    maxHeight: "700px", // Limit to phone height
  },
  statusBar: {
    position: "absolute",
    top: "5px",
    left: 0,
    right: 0,
    padding: "15px",
    display: "flex",
    justifyContent: "space-between",
    color: "#000",
    fontSize: "14px",
    zIndex: 5,
  },
  smsHeader: {
    background: "#007AFF", // iOS Messages blue or use #34C759 for green
    color: "#fff",
    padding: "60px 16px 16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  chatBackground: {
    background: "#F2F2F7", // iOS Messages background color
    height: "calc(100%)",
    padding: "16px",
    // Remove maxHeight here, let the screen handle scroll
    minHeight: "120px",
  },
  messageBubble: {
    maxWidth: "85%",
    // Remove maxHeight here
    marginLeft: "auto",
    background: "#007AFF", // Blue bubble for sent messages
    borderRadius: "18px",
    padding: "12px 16px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    marginBottom: "8px",
    color: "#fff", // White text for sent messages
  },
  receivedMessageBubble: {
    maxWidth: "85%",
    marginRight: "auto",
    marginLeft: "0",
    background: "#E9E9EB", // Gray bubble for received messages
    borderRadius: "18px",
    padding: "12px 16px",
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    marginBottom: "8px",
    color: "#000", // Black text for received messages
  },
  messageTime: {
    fontSize: "11px",
    opacity: 0.7,
    marginTop: "4px",
    textAlign: "right",
  },
  inputArea: {
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    background: "#F2F2F7",
    padding: "12px 16px",
    borderTop: "1px solid #C6C6C8",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  textInput: {
    flex: 1,
    background: "#fff",
    border: "1px solid #C6C6C8",
    borderRadius: "20px",
    padding: "8px 16px",
    outline: "none",
    fontSize: "16px",
  },
  sendButton: {
    background: "#007AFF",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
};

export default function SMSPreview({ messageText, recipientName, showInput = true }) {
  return (
    <div style={phoneStyles.container}>
      {/* Dynamic Island (iPhone 14+ style) */}
      <div style={phoneStyles.dynamicIsland}></div>
      {/* Phone Screen */}
      <div style={phoneStyles.screen}>
        {/* Status Bar */}
        <div style={phoneStyles.statusBar}>
          <span>9:41</span>
          <span>100%</span>
        </div>
        {/* SMS Header */}
        <div style={phoneStyles.smsHeader}>
          <MessageSquare size={20} />
          <div>
            <Typography variant="subtitle2">
              {recipientName || "Messages"}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              SMS Preview
            </Typography>
          </div>
        </div>
        {/* Chat Background */}
        <div style={phoneStyles.chatBackground}>
          {/* Sample received message */}
          <div style={phoneStyles.receivedMessageBubble}>
            <Typography variant="body2">
              Hey! How are you doing?
            </Typography>
            <div style={{ ...phoneStyles.messageTime, color: "#8E8E93" }}>
              2:30 PM
            </div>
          </div>
          {/* Your SMS message (sent) */}
          <div style={phoneStyles.messageBubble}>
            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
              {messageText || "Your SMS message will appear here"}
            </Typography>
            <div style={phoneStyles.messageTime}>
              2:32 PM
            </div>
          </div>
        </div>
        {/* Input Area (optional) */}
        {showInput && (
          <div style={phoneStyles.inputArea}>
            <input 
              type="text" 
              placeholder="Text Message" 
              style={phoneStyles.textInput}
            />
            <button style={phoneStyles.sendButton}>
              ↑
            </button>
          </div>
        )}
      </div>
    </div>
  );
} 